export default __webpack_public_path__ + "locales/pt/RoomLogoCover.json?hash=a1f46293418b740915e1503205d30d14";